import { tryCatch } from '@thalesrc/js-utils';

import HSApi from 'api/hs/HSApi';

import { EnumIbysPhysicalWorkConditions } from './enum-ibys-physical-work-conditions.result';
import { EnumResult } from './enum.result';
const detailPath = '/ibys/physical-work-conditions/chemical-matter-definitions';

export async function getPhysicalWorkConditionChemicalMatterDefinitions(): Promise<EnumResult[]> {
  const [error, res] = await tryCatch(HSApi.get<EnumIbysPhysicalWorkConditions[]>(`${detailPath}`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }
  const resultArray: EnumResult[] = [];
  res.data.forEach(value => {
    const resultVal: EnumResult = {
      createdBy: value.createdBy,
      createdDate: value.createdDate,
      lastModifiedBy: value.lastModifiedBy,
      lastModifiedDate: value.lastModifiedDate,
      deleted: value.deleted,
      id: value.code,
      label: value.name,
    };
    resultArray.push(resultVal);
  });

  return resultArray;
}
